import axios from 'axios'
// import router from '../router'
import store from '../store'
import getUser from './api'

const request = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? 'http://fun.guangxifxj.cn'
    : 'http://fun.guangxifxj.cn',
  timeout: 5000
})

// http request 请求拦截器
request.interceptors.request.use(config => {
  // 携带用户token信息
  if (localStorage.token) {
    config.headers.Authorization = localStorage.token
    config.headers.Accept = 'application/json'
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 用户模块api
const user = getUser(request, store)

export default {
  ...user
}
